import { log } from "../Helper";

const saveFilterState = (tableName, filters) => {
    try {
      sessionStorage.setItem(`${tableName}_filterState`, JSON.stringify(filters));
    } catch (error) {
      log('Failed to save filter state:', error);
    }
  };
   
  const getFilterState = (tableName) => {
    try {
      const savedFilters = sessionStorage.getItem(`${tableName}_filterState`);
      return savedFilters ? JSON.parse(savedFilters) : {};
    } catch (error) {
      log('Failed to retrieve filter state:', error);
      return {};
    }
  };
   
  export { saveFilterState, getFilterState };